import { get } from 'lodash';
import Cookies from 'js-cookie';
import DatadogHandler from 'utils/datadog';
import SkRequest from './BaseRequest';
import { QueryBuilder, MutationBuilder } from '../queryBuilder';
import {
  LOGIN_USER,
  FORGOT_PASSWORD_REQUEST,
  REGISTER_USER_PASSWORD,
  RESET_USER_PASSWORD,
  APPROVER_ACCESS,
  FETCH_USER_DETAILS,
  ACCESSIBLE_CENTRES,
  VALIDATE_REGISTERED_USER,
  FETCH_SSO_URL,
  LINKPASS_USER_INFO_FROM_CLAIM,
  LOGIN_BY_LINKPASS,
  LINK_USER_WITH_LINKPASS,
  LINK_USER_WITH_LINKPASS_AND_LOGIN,
  REGISTER_WITH_LINKPASS,
  LINKPASS_SN2_USER_INFO,
  FETCH_USER_CLASS_LEVELS,
} from './actionTypes';
import {
  ME,
  LOGIN,
  GET_APPROVER_LIST,
  LinkUserWithLinkPassAndLogin,
  LinkpassSN2UserInfo,
  LinkpassUserInfoFromClaim,
  LoginByLinkPass,
  LinkUserWithLinkPass,
  RegisterWithLinkpass,
  RegisterWithLinkPassInfo,
  LOGIN_FOR_EP_TOKEN,
  UpdateElectronicConsentStatusGQL,
} from '../models/authModels';
import { SkApolloRequest } from '../../utils/apolloUtils';
import localstorage from '../../utils/localStorage';
import { SkApolloRequestWithoutHeaders } from '../../utils/apolloUtilsWithoutHeaders';
import { actionHandlerWithFeatureFlag } from '../../utils';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  msFetchAccessibleCentreForModule,
  msFetchUserDetails,
  msForgotPassword,
  msGetSsoURL,
  msLogin,
  msLoginByLinkpass,
  msLinkUserWithLinkPass,
  msRegisterWithLinkPass,
  msValidateOtp,
  msResetPassword,
  msLoginForEpToken,
} from '../../services/AuthService';
import {
  msLinkpassUserInfoFromClaim,
  msLinkUserWithLinkPassAndLogin,
  msLinkpassSn2UserInfo,
  msRegisterWithLinkPassInfo,
  msValidateUser,
  msUpdateElectronicConsentStatus,
} from '../../services/UserService';
import { AxiosHelper } from '../../utils/ms-utils/axiosRequest';
import { MS_PHASE_2B_CLASS_ACTIVITY_ENPOINT } from '../../utils/msEndpointConstants';

const fileName = 'src/redux/actions/Auth.js';
const _mQueryBuilder = new QueryBuilder();
const _mMutationAuthBuilder = new MutationBuilder();
const { CLASS } = MS_PHASE_2B_CLASS_ACTIVITY_ENPOINT;

_mQueryBuilder.setNewQuery('getAccessibleCentresForModule', {
  data: {
    ID: 'number',
    fkSchool: 'number',
    label: 'String',
  },
});

_mQueryBuilder.setNewQuery('getLoginUrl', {});

_mMutationAuthBuilder.setNewMutation('forgetPassword', {});
_mMutationAuthBuilder.setNewMutation('register', {
  ID: 'int',
  firstname: 'string',
  lastname: 'string',
  email: 'string',
  active: 'boolean',
  createdAt: 'datestamp',
  updatedAt: 'datestamp',
});
_mMutationAuthBuilder.setNewMutation('resetPassword', {});
_mQueryBuilder.setNewQuery('validateUser', {
  email: 'string',
  registered: 'boolean',
  phoneNumber: 'number',
  EConsentStatus: 'boolean',
  CreatedAt: 'datestamp',
});

_mMutationAuthBuilder.setNewMutation('sendOTP', {});
_mMutationAuthBuilder.setNewMutation('validateOTP', {});

const dispatchApproverList = (
  dispatch,
  inProgress = true,
  data = null,
  error = null
) => {
  dispatch({
    type: APPROVER_ACCESS,
    key: 'approverList',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAcessibleCentres = (
  dispatch,
  inProgress = true,
  data = [],
  error = null
) => {
  dispatch({
    type: ACCESSIBLE_CENTRES,
    key: 'approverList',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLogin = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LOGIN_USER,
    key: 'login',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLinkpassUserInfoFromClaim = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LINKPASS_USER_INFO_FROM_CLAIM,
    key: 'linkpassUserInfoFromClaim',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchRegisterWithLinkPassInfo = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: RegisterWithLinkPassInfo,
    key: 'registerWithLinkPassInfo',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLoginByLinkpass = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LOGIN_BY_LINKPASS,
    key: 'loginByLinkpass',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLinkpassSn2UserInfo = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LINKPASS_SN2_USER_INFO,
    key: 'linkpassSn2UserInfo',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLinkUserWithLinkPassAndLogin = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LINK_USER_WITH_LINKPASS_AND_LOGIN,
    key: 'linkUserWithLinkpassAndLogin',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchRegisterWithLinkPass = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: REGISTER_WITH_LINKPASS,
    key: 'registerWithLinkPass',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchUpdateElectronicConsentStatus = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LINK_USER_WITH_LINKPASS,
    key: 'updateElectronicConsentStatus',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchLinkUserWithLinkpass = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: LINK_USER_WITH_LINKPASS,
    key: 'linkUserWithLinkpass',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSSOURL = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_SSO_URL,
    key: 'sso_url',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchForgot = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FORGOT_PASSWORD_REQUEST,
    key: 'forgot',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchValidateUser = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: VALIDATE_REGISTERED_USER,
    key: 'validateUser',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoValidateUser = async (_, tokenString) => {
  try {
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('validateUser', {
          tokenString,
        }),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoValidateUser',
      },
      'error'
    );
    return { error: ex.message };
  }
};

export const validateUser = tokenString => async dispatch => {
  dispatchValidateUser(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msValidateUser,
        monoHandler: monoValidateUser,
        extraData: tokenString,
      }
    );

    if (data.success) {
      dispatchValidateUser(dispatch, false, data);
    } else {
      dispatchValidateUser(dispatch, false, null, data.error);
    }

    return data;
  } catch (ex) {
    dispatchValidateUser(dispatch, false, null, { error: ex.message });
  }
};

export const monoFetchApproverList = async (
  dispatch,
  { module, accessType }
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_APPROVER_LIST,
        variables: {
          module,
          accessType,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchApproverList',
        fileName,
      },
      'error'
    );
    dispatchApproverList(dispatch, false, null, { error: ex.message });
    return { error: ex.message };
  }
};

export const fetchApproverList = module => async dispatch => {
  dispatchApproverList(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchAccessibleCentreForModule,
        monoHandler: monoFetchApproverList,
        extraData: {
          module,
          accessType: 'approve',
        },
      }
    );
    if (data.success) {
      dispatchApproverList(dispatch, false, data);
    } else {
      dispatchApproverList(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoFetchAccessibleCentreForModule = async (_, reqBody) => {
  const {
    module,
    accessType = 'read',
    includeClosedCentres = true,
    pagination = {},
  } = reqBody;
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_APPROVER_LIST,
        variables: {
          module,
          accessType,
          includeClosedCentres,
          pagination,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAccessibleCentreForModule',
        fileName,
      },
      'error'
    );
    return {
      success: false,
    };
  }
};

export const fetchAccessibleCentreForModule =
  (module, accessType = 'read', includeClosedCentres = true, pagination = {}) =>
  async dispatch => {
    dispatchAcessibleCentres(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msFetchAccessibleCentreForModule,
        monoHandler: monoFetchAccessibleCentreForModule,
        dispatch,
        extraData: { module, accessType, includeClosedCentres, pagination },
      }
    );
    if (data.success) {
      dispatchAcessibleCentres(dispatch, false, data);
    } else {
      dispatchAcessibleCentres(dispatch, false, null, data.error);
    }

    return data;
  };

export const monoForgotPassword = email => async dispatch => {
  try {
    const data = await SkRequest({
      data: {
        query: _mMutationAuthBuilder.getMutationAsString('forgetPassword', {
          email,
        }),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    dispatchForgot(dispatch, false, null, { error: ex.message });
  }
};

export const forgotPassword = email => async dispatch => {
  dispatchForgot(dispatch);

  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msForgotPassword,
      monoHandler: monoForgotPassword,
      extraData: {
        email,
      },
    }
  );
  if (data.success) {
    dispatchForgot(dispatch, false, data);
  } else {
    dispatchForgot(dispatch, false, null, data.error);
  }
  return data;
};

export const monoLinkpassUserInfoFromClaim = async (_, reqData) => {
  const { linkPassIdToken } = reqData;
  try {
    const data = await SkApolloRequest({
      params: {
        query: LinkpassUserInfoFromClaim,
        variables: {
          linkPassIdToken,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const linkpassUserInfoFromClaim = linkPassIdToken => async dispatch => {
  dispatchLinkpassUserInfoFromClaim(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msLinkpassUserInfoFromClaim,
        monoHandler: monoLinkpassUserInfoFromClaim,
        extraData: {
          linkPassIdToken,
        },
      }
    );
    if (data.success) {
      dispatchLinkpassUserInfoFromClaim(dispatch, false, data, null);
    } else {
      dispatchLinkpassUserInfoFromClaim(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchLinkpassUserInfoFromClaim(dispatch, false, null, ex?.message);
    return { error: ex?.message };
  }
};

export const monoRegisterWithLinkPassInfo = async (dispatch, reqData) => {
  const { registerToken, linkPassIdToken } = reqData;
  dispatchRegisterWithLinkPassInfo(dispatch);
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: RegisterWithLinkPassInfo,
        variables: {
          token: registerToken,
          linkPassIdToken,
        },
      },
      type: 'mutation',
    });
    if (data.success) {
      dispatchRegisterWithLinkPassInfo(dispatch, false, data, null);
    } else {
      dispatchRegisterWithLinkPassInfo(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    dispatchRegisterWithLinkPassInfo(dispatch, false, null, errorMessage);
    return ex;
  }
};

export const registerWithLinkPassInfo =
  (registerToken, linkPassIdToken) => async dispatch => {
    dispatchRegisterWithLinkPassInfo(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msRegisterWithLinkPassInfo,
          monoHandler: monoRegisterWithLinkPassInfo,
          extraData: {
            registerToken,
            linkPassIdToken,
          },
        }
      );
      if (data.success) {
        dispatchRegisterWithLinkPassInfo(dispatch, false, data, null);
      } else {
        dispatchRegisterWithLinkPassInfo(dispatch, false, null, data.error);
      }
      return data;
    } catch (ex) {
      dispatchRegisterWithLinkPassInfo(dispatch, false, null, ex?.message);
      return { error: ex?.message };
    }
  };

export const registerWithLinkPass =
  (registerToken, linkPassIdToken) => async dispatch => {
    dispatchRegisterWithLinkPass(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msRegisterWithLinkPass,
          monoHandler: async () =>
            SkApolloRequest({
              params: {
                mutation: RegisterWithLinkpass,
                variables: {
                  token: registerToken,
                  linkPassIdToken,
                },
              },
              type: 'mutation',
            }),
          extraData: { registerToken, linkPassIdToken },
        }
      );
      if (data.success) {
        dispatchRegisterWithLinkPass(dispatch, false, data, null);
      } else {
        dispatchRegisterWithLinkPass(dispatch, false, null, data.error);
      }
      return data;
    } catch (ex) {
      const errorMessage = ex.message.replace(/GraphQL error./, '');
      dispatchRegisterWithLinkPass(dispatch, false, null, errorMessage);
      return { error: errorMessage };
    }
  };

export const monoLinkUserWithLinkPass = async (
  _,
  { email, linkPassIdToken }
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: LinkUserWithLinkPass,
        variables: {
          email,
          linkPassIdToken,
        },
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const linkUserWithLinkPass =
  (email, linkPassIdToken) => async dispatch => {
    dispatchLinkUserWithLinkpass(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msLinkUserWithLinkPass,
          monoHandler: monoLinkUserWithLinkPass,
          extraData: { email, linkPassIdToken },
        }
      );

      if (data.success) {
        dispatchLinkUserWithLinkpass(dispatch, false, data, null);
      } else {
        dispatchLinkUserWithLinkpass(dispatch, false, null, data.error);
      }
      return data;
    } catch (ex) {
      const errorMessage = ex.message.replace(/GraphQL error./, '');
      dispatchLinkUserWithLinkpass(dispatch, false, null, errorMessage);
      return { error: errorMessage };
    }
  };

export const monoLinkUserWithLinkPassAndLogin = async (dispatch, reqData) => {
  const { email, password, linkPassIdToken } = reqData;
  dispatchLinkUserWithLinkPassAndLogin(dispatch);
  try {
    const data = await SkApolloRequest({
      params: {
        query: LinkUserWithLinkPassAndLogin,
        variables: {
          email,
          password,
          linkPassIdToken,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    dispatchLinkUserWithLinkPassAndLogin(dispatch, false, null, errorMessage);
    return { error: errorMessage };
  }
};

export const linkUserWithLinkPassAndLogin =
  (email, password, linkPassIdToken) => async dispatch => {
    dispatchLinkUserWithLinkPassAndLogin(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msLinkUserWithLinkPassAndLogin,
          monoHandler: monoLinkUserWithLinkPassAndLogin,
          extraData: {
            email,
            password,
            linkPassIdToken,
          },
        }
      );
      if (data.success) {
        localstorage.setValue(
          'userToken',
          get(data, 'data.linkUserWithLinkPassAndLogin')
        );

        dispatchLinkUserWithLinkPassAndLogin(dispatch, false, data, null);
      } else {
        dispatchLinkUserWithLinkPassAndLogin(dispatch, false, null, data.error);
      }
      return data;
    } catch (ex) {
      dispatchLinkUserWithLinkPassAndLogin(dispatch, false, null, ex?.message);
      return { error: ex?.message };
    }
  };

export const monoLinkpassSn2UserInfo = async (_, reqData) => {
  try {
    const { email, password, linkPassIdToken } = reqData;
    const data = await SkApolloRequest({
      params: {
        query: LinkpassSN2UserInfo,
        variables: {
          email,
          password,
          linkPassIdToken,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return {
      success: false,
      error: [
        {
          message: errorMessage,
        },
      ],
    };
  }
};

export const linkpassSn2UserInfo =
  (email, password, linkPassIdToken) => async dispatch => {
    dispatchLinkpassSn2UserInfo(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msLinkpassSn2UserInfo,
          monoHandler: monoLinkpassSn2UserInfo,
          extraData: {
            email,
            password,
            linkPassIdToken,
          },
        }
      );
      if (data.success) {
        dispatchLinkpassSn2UserInfo(dispatch, false, data, null);
      } else {
        dispatchLinkpassSn2UserInfo(dispatch, false, null, data.error);
      }
      return data;
    } catch (ex) {
      const errorMessage = ex.message.replace(/GraphQL error./, '');
      dispatchLinkpassSn2UserInfo(dispatch, false, null, errorMessage);
      return { error: errorMessage };
    }
  };

export const monoGetSsoURL = async (_, fkSchool) => {
  try {
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('getLoginUrl', {
          fkSchool,
        }),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoGetSsoURL',
      },
      'error'
    );
    throw ex;
  }
};

export const getSSOURL = fkSchool => async dispatch => {
  dispatchSSOURL(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetSsoURL,
        monoHandler: monoGetSsoURL,
        extraData: fkSchool,
      }
    );

    if (data.success) {
      dispatchSSOURL(dispatch, false, data);
    } else {
      dispatchSSOURL(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchSSOURL(dispatch, false, null, { error: ex.message });
  }
};

const dispatchRegister = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: REGISTER_USER_PASSWORD,
    key: 'register',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoUpdateElectronicConsentStatus = async (
  _,
  { tokenString, consentStatus }
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UpdateElectronicConsentStatusGQL,
        variables: {
          tokenString,
          consentStatus,
        },
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoUpdateElectronicConsentStatus',
      },
      'error'
    );
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    return { error: errorMessage };
  }
};

export const updateElectronicConsentStatus =
  (tokenString, consentStatus) => async dispatch => {
    dispatchUpdateElectronicConsentStatus(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msUpdateElectronicConsentStatus,
          monoHandler: monoUpdateElectronicConsentStatus,
          extraData: { tokenString, consentStatus },
        }
      );

      if (data.success) {
        dispatchUpdateElectronicConsentStatus(dispatch, false, data, null);
      } else {
        dispatchUpdateElectronicConsentStatus(
          dispatch,
          false,
          null,
          data.error
        );
      }
      return data;
    } catch (ex) {
      const errorMessage = ex.message.replace(/GraphQL error./, '');
      dispatchUpdateElectronicConsentStatus(
        dispatch,
        false,
        null,
        errorMessage
      );
      return { error: errorMessage };
    }
  };

export const registerPassword = (token, password) => async dispatch => {
  dispatchRegister(dispatch);

  try {
    const data = await SkRequest({
      data: {
        query: _mMutationAuthBuilder.getMutationAsString('register', {
          token,
          password,
        }),
      },
      method: 'POST',
    });

    if (data.success) {
      dispatchRegister(dispatch, false, data);
    } else {
      dispatchRegister(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchRegister(dispatch, false, null, { error: ex.message });
  }
};

const dispatchReset = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: RESET_USER_PASSWORD,
    key: 'reset',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchUserDetails = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_USER_DETAILS,
    key: 'userDetails',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const sendOtp = userId => async () => {
  try {
    const data = await SkRequest({
      data: {
        query: _mMutationAuthBuilder.getMutationAsString('sendOTP', userId),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoValidateOtp = async (_, reqData) => {
  try {
    const data = await SkRequest({
      data: {
        query: _mMutationAuthBuilder.getMutationAsString(
          'validateOTP',
          reqData
        ),
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoValidateOtp',
      },
      'error'
    );
    throw ex;
  }
};

export const validateOtp = reqData => async () => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msValidateOtp,
        monoHandler: monoValidateOtp,
        extraData: reqData,
      }
    );
    return data;
  } catch (ex) {
    return {
      success: false,
      error: [
        {
          message: get(ex, 'message', 'An error occurred'),
        },
      ],
    };
  }
};

export const monoResetPassword = async (_, { tokenString, password }) => {
  try {
    return SkRequest({
      data: {
        query: _mMutationAuthBuilder.getMutationAsString('resetPassword', {
          tokenString,
          password,
        }),
      },
      method: 'POST',
    });
  } catch (ex) {
    return ex;
  }
};

export const resetPassword = (tokenString, password) => async dispatch => {
  dispatchReset(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msResetPassword,
        monoHandler: monoResetPassword,
        extraData: {
          tokenString,
          password,
        },
      }
    );

    if (data.success) {
      dispatchReset(dispatch, false, data);
    } else {
      dispatchReset(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchReset(dispatch, false, null, { error: ex.message });
    return ex;
  }
};

export const fetchTeacherClassLevels = teacherId => async dispatch => {
  const res = await AxiosHelper({
    baseURL: process.env.REACT_APP_MS_CLASS_SVC_URL,
  }).get(CLASS.GET_TEACHER_CLASS_LEVELS(teacherId));
  dispatch({
    type: FETCH_USER_CLASS_LEVELS,
    key: 'userClassLevels',
    value: {
      data: get(res, 'data.level.data') || [],
    },
  });
  return get(res, 'data.level.data') || [];
};

export const monoFetchUserDetails = async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: ME,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoFetchUserDetails',
      },
      'error'
    );
    return {
      success: false,
      error: { error: ex.message },
    };
  }
};

export const fetchUserDetails = () => async dispatch => {
  dispatchUserDetails(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchUserDetails,
      monoHandler: monoFetchUserDetails,
    }
  );

  if (data.success) {
    const isStaff = !!get(
      data,
      'data.me.userRoleRelations.data[0].role.isStaff',
      false
    );
    if (isStaff) {
      await dispatch(fetchTeacherClassLevels(get(data, 'data.me.ID')));
    }
    dispatchUserDetails(dispatch, false, data.data);
  } else {
    dispatchUserDetails(dispatch, false, null, data.error);
  }
  return data;
};

export const monoLoginForEpToken = async (_, { token }) => {
  try {
    const bearerToken = `Bearer ${token}`;
    const data = await SkApolloRequestWithoutHeaders({
      params: {
        query: LOGIN_FOR_EP_TOKEN,
        context: {
          headers: { Authorization: bearerToken },
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'loginForEpToken',
        portal: 'Web',
      },
      'error'
    );
    return { error: errorMessage };
  }
};

export const loginForEpToken = token => async dispatch => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msLoginForEpToken,
        monoHandler: monoLoginForEpToken,
        extraData: {
          token,
        },
      }
    );
    if (data.success) {
      return data;
    }
  } catch (ex) {
    dispatchReset(dispatch, false, null, { error: ex.message });
    return ex;
  }
};

export const loginByLinkpass = linkPassIdToken => async dispatch => {
  dispatchLoginByLinkpass(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msLoginByLinkpass,
        monoHandler: async (_, { linkPassIdToken: token }) =>
          SkApolloRequest({
            params: {
              query: LoginByLinkPass,
              variables: {
                linkPassIdToken: token,
              },
            },
            type: 'query',
          }),
        extraData: { linkPassIdToken },
      }
    );

    if (data.success) {
      const tokenValue = get(data, 'data.loginByLinkPass');
      localstorage.setValue('userToken', tokenValue);
      dispatchLoginByLinkpass(dispatch, false, data, null);
      const response = await loginForEpToken(tokenValue);
      const errors = get(response, 'error', null);
      if (!errors) {
        Cookies.set('epUserToken', get(response, 'data.loginEP'), {
          path: '',
          domain: process.env.REACT_APP_DOMAIN || '.skool.sg',
        });
      }
    } else {
      dispatchLoginByLinkpass(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    dispatchLoginByLinkpass(dispatch, false, null, errorMessage);
    return { error: errorMessage };
  }
};

export const monoLoginUser = async (dispatch, reqBody) => {
  try {
    return SkApolloRequest({
      params: {
        query: LOGIN,
        variables: reqBody,
      },
      type: 'query',
    });
  } catch (ex) {
    const errorMessage = ex.message.replace(/GraphQL error./, '');
    dispatchLogin(dispatch, false, null, errorMessage);
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoLoginUser',
        fileName,
      },
      'error'
    );
    return { error: errorMessage };
  }
};

export const loginUser = (email, password) => async dispatch => {
  dispatchLogin(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msLogin,
      monoHandler: monoLoginUser,
      extraData: {
        email,
        password,
      },
    }
  );
  if (data.success) {
    localstorage.setValue('userToken', data.data.login);
    dispatchLogin(dispatch, false, data.data, null);
    const response = await loginForEpToken(get(data, 'data.login'));
    const errors = get(response, 'error', null);
    if (!errors) {
      Cookies.set('epUserToken', get(response, 'data.loginEP'), {
        path: '',
        domain: process.env.REACT_APP_DOMAIN || '.skool.sg',
      });
    }
  } else {
    dispatchLogin(dispatch, false, null, data.error);
  }

  return data;
};

export default {
  loginUser,
  fetchUserDetails,
  validateUser,
  fetchApproverList,
  fetchAccessibleCentreForModule,
  forgotPassword,
  loginByLinkpass,
  linkpassUserInfoFromClaim,
  registerWithLinkPass,
  linkUserWithLinkPass,
  linkUserWithLinkPassAndLogin,
  linkpassSn2UserInfo,
  getSSOURL,
  registerPassword,
  sendOtp,
  validateOtp,
  resetPassword,
  loginForEpToken,
  fetchTeacherClassLevels,
};
